import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DocumentManagementService } from 'src/framework/services/manage-doc.service';
import { SelectItemGroup, SelectItem, MessageService } from 'primeng/api';
import { NgxSpinnerService } from 'ngx-spinner';
import { LabelcardMgmtService } from 'src/framework/services/labelcard-mgmt.service';
import { LanguageService } from 'src/framework/services/language.service';
import { CategoryConstant } from 'src/app/shared/app-constants/category-constants';
import { ignoreElements } from 'rxjs/operators';


@Component({
  selector: 'app-upload-new-doc',
  templateUrl: './upload-new-doc.component.html',
  styleUrls: ['./upload-new-doc.component.css'],
  providers: [MessageService]
})

export class UploadNewDocComponent implements OnInit {

  @Input() docLanguageId: number;
  @Input() docFolderId: string;
  @Input() absoluteFilePath: string;
  @Output() emitDocument = new EventEmitter<any>();
  @ViewChild("ctrlFileUpload") ctrlFileUpload: ElementRef;

  docTypeKeyValueList: SelectItem[];
  allowedFileTypes: string;
  calendarYearRange: string;
  pUpload: any;
  tinyMceConfig:any;
  docTypeList: any[] = [];
  docInfo = '';
  docDateDesc = 'Document Date';
  authorizerList: SelectItemGroup[] = [
    {
      label: 'Owners',
      items: []
    },
    {
      label: 'Reviewers',
      items: []
    },
    {
      label: 'PPAP',
      items: []
    },
    {
      label: 'Sr. Managers',
      items: []
    },
    {
      label: 'Admin',
      items: []
    }
  ];

  engagementDetail = {
    appLanguage: 1,
    engagementId: 1,
    engagementName: '',
    engStatusId: 1,
    engStatusName: '',
    engInitialDate: null,
    engLanguage: [{
      "languageId": 1,
      "languageName": "English",
      "languageFlagPath": "../../assets/flags/English.png"
    }],
    engLanguageFrench: [{
      "languageId": 1,
      "languageName": "Anglaise",
      "languageFlagPath": "../../assets/flags/English.png"
    }]
  }

  documentForm: FormGroup;
  formSubmitted = false;
  showDateMandatory: boolean = false;
  appLangList: any[] = [];
  selectedAppLanguage: any;
  selectedAppLanguageJson: any;
  defaultEnglishJson: any;
  selectedLangDocTypeJson: any;
  defaultEngDocTypeJson: any;
  selectedLangDateJson: any;
  defaultEngDateJson: any;
  islabelLoaded: boolean = false;
  isDocTypeLoaded: boolean = false;
  fontSizeList: SelectItem[];
  userDetail: any = {};
  showApproveButton: boolean = false;
  isApproverSelected: boolean = false;
  errorMsg: string = '';
  approverRemovedNote: string;
  rawApproverList: any[] = [];
  emitVersionResponse: any = {
    saveType: '',
    versionData: {}
  };
  isFontLoaded: boolean = false;
  localeSetting: any;
  apporveBtnState: boolean = false;

  constructor(private formBuilder: FormBuilder,
    private manageDocService: DocumentManagementService, private spinner: NgxSpinnerService,
    private messageService: MessageService,
    private labelCardService: LabelcardMgmtService, private languageService: LanguageService) {

    this.allowedFileTypes = ".doc,.docx,.dot,.jpg,.jpeg,.png,.tif,.pdf,.xls,.xlsx,.xlsb";
    this.calendarYearRange = (new Date().getUTCFullYear() - 10) + ':' + (new Date().getUTCFullYear() + 1);
  }

  ngOnInit(): void {

    this.approverRemovedNote = null;
    if (sessionStorage.getItem('userDetail')) {
      this.userDetail = JSON.parse(sessionStorage.getItem('userDetail'));
    }
    this.configureTinyMce();
    this.loadLanguageLabel()
      .then(res => {
        this.getDocType()
          .then(res => {
            this.initializeEngagementData()
              .then(res => {
                this.buildForm();
                this.setDocDateValidators();
                this.getApproverList(+this.engagementDetail.engagementId)
                  .then(res => {
                    this.formatApproverList()
                  })
                  .catch(err => {
                    console.log(err);
                  })
              })
              .catch(err => {
                console.log(err);
              })
          })
          .catch(err => {
            console.log(err);
          })
      })
      .catch(err => {
        console.log(err);
      })
  }

  initializeEngagementData() {

    return new Promise((resolve, reject) => {
      if (sessionStorage.getItem('appLanguageList')) {
        this.appLangList = JSON.parse(sessionStorage.getItem('appLanguageList'));
      }
      else {
        this.getLanguageList();
      }


      if (sessionStorage.getItem('engagementDetail')) {
        this.engagementDetail = JSON.parse(sessionStorage.getItem('engagementDetail'));
        const minYear =
          Number(new Date().getUTCFullYear() - 10) <
            Number(new Date(this.engagementDetail?.engInitialDate).getUTCFullYear()) ?
            Number(new Date().getUTCFullYear() - 10) :
            Number(new Date(this.engagementDetail?.engInitialDate).getUTCFullYear());

        this.calendarYearRange = minYear + ':' + (new Date().getUTCFullYear() + 1);
      }
      resolve(1);
    });
  }

  setCalendarLocale() {
    this.localeSetting = {
      firstDayOfWeek: 0,
      dayNames: [
        this.calendarReplacer("SUN"),
        this.calendarReplacer("MON"), this.calendarReplacer("TUE"), this.calendarReplacer("WED"),
        this.calendarReplacer("THU"), this.calendarReplacer("FRI"), this.calendarReplacer("SAT")
      ],
      dayNamesShort: [
        this.dayOrMonthNameShort(this.calendarReplacer("SUN"), 3),
        this.dayOrMonthNameShort(this.calendarReplacer("MON"), 3), this.dayOrMonthNameShort(this.calendarReplacer("TUE"), 3),
        this.dayOrMonthNameShort(this.calendarReplacer("WED"), 3), this.dayOrMonthNameShort(this.calendarReplacer("THU"), 3),
        this.dayOrMonthNameShort(this.calendarReplacer("FRI"), 3), this.dayOrMonthNameShort(this.calendarReplacer("SAT"), 3)
      ],
      dayNamesMin: [
        this.dayOrMonthNameShort(this.calendarReplacer("SUN"), 1),
        this.dayOrMonthNameShort(this.calendarReplacer("MON"), 1), this.dayOrMonthNameShort(this.calendarReplacer("TUE"), 1),
        this.dayOrMonthNameShort(this.calendarReplacer("WED"), 1), this.dayOrMonthNameShort(this.calendarReplacer("THU"), 1),
        this.dayOrMonthNameShort(this.calendarReplacer("FRI"), 1), this.dayOrMonthNameShort(this.calendarReplacer("SAT"), 1)
      ],
      monthNames: [
        this.calendarReplacer("JAN"), this.calendarReplacer("FEB"), this.calendarReplacer("MAR"),
        this.calendarReplacer("APR"), this.calendarReplacer("MAY"), this.calendarReplacer("JUN"),
        this.calendarReplacer("JUL"), this.calendarReplacer("AUG"), this.calendarReplacer("SEP"),
        this.calendarReplacer("OCT"), this.calendarReplacer("NOV"), this.calendarReplacer("DEC")
      ],
      monthNamesShort: [
        this.calendarReplacer("JAN"), this.calendarReplacer("FEB"), this.calendarReplacer("MAR"),
        this.calendarReplacer("APR"), this.calendarReplacer("MAY"), this.calendarReplacer("JUN"),
        this.calendarReplacer("JUL"), this.calendarReplacer("AUG"), this.calendarReplacer("SEP"),
        this.calendarReplacer("OCT"), this.calendarReplacer("NOV"), this.calendarReplacer("DEC")
      ],
      today: this.calendarReplacer('TODAY'),
      clear: this.calendarReplacer('CLEAR')
    }
  }


  configureTinyMce() {
    const that = this;
    this.tinyMceConfig = {
      branding: false,
      toolbar_mode: 'sliding',
      toolbar_sticky: false,
      inline: false,
      statusbar: false,
      theme: "silver",
      resize: false,
      skin: "oxide",
      skin_url: 'assets/skins/ui/oxide',
      base_url: '/tinymce',  
      suffix: '.min',
      plugins: [
        "print preview   importcss autoresize searchreplace autolink autosave save directionality  visualblocks visualchars fullscreen image link media  template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists  wordcount   imagetools textpattern noneditable help code charmap  emoticons paste table"],
      menubar: 'edit insert view  format table tools help',
      force_br_newlines: false,
      //force_p_newlines: false,
      //forced_root_block: '',
      // content_css: [
      //   '//fonts.googleapis.com/css?family=EYFontRegular',
      // ],
      paste_as_text: true,
      paste_text_sticky: true,
      font_formats: 'EYFontRegular=EYFontRegular;',
      theme_advanced_fonts: "EYFontRegular=EYFontRegular",
      extended_valid_elements: "@[id|class|title|style|onmouseover|onclick]," +
        "a[name|href=javascript:void(0);|target|title|alt]," +
        "#div,blockquote,-ol,-ul,-li,br,img[src|height|width],-sub,-sup,-b,-i,-u," +
        "-span[data-mce-type],hr,",
      toolbar: 'bold italic backcolor | ' +
        'bullist numlist outdent indent | alignright alignjustify |' +
        '   alignleft aligncenter | removeformat |' +
        ' help '
    };
  }

  loadLanguageLabel() {
    let englishLanguageMappings, selectedLanguageMappings: any;
    let englishDocTypeMappings, selectedLangDocTypeMappings: any;
    let englishDateMappings, selectedLangDateMappings: any;

    return new Promise((resolve, reject) => {
      this.spinner.show();
      if (sessionStorage.getItem('selectedLanguageId')) {
        this.selectedAppLanguage = 1;//JSON.parse(sessionStorage.getItem('selectedLanguageId'));
      }

      this.languageService.currentData.subscribe(data => {
        this.selectedAppLanguage = data.Id
        this.isFontLoaded = false;
      });


      this.languageService.mySubject.subscribe((data) => {
        var languageMappings = data;
        if (languageMappings?.length > 0) {

          englishLanguageMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.UploadDocument.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          englishDocTypeMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.DocumentTypes.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          englishDateMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.Calendar.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          if (englishLanguageMappings?.isGlobal) {
            selectedLanguageMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.UploadDocument.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];

            selectedLangDocTypeMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.DocumentTypes.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];

            selectedLangDateMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.Calendar.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];
          }
          else {
            if (Number(this.selectedAppLanguage) === 2) {
              selectedLanguageMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.UploadDocument.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];

              selectedLangDocTypeMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.DocumentTypes.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];

              selectedLangDateMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.Calendar.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];
            }
            else {
              selectedLanguageMappings = englishLanguageMappings;
              selectedLangDocTypeMappings = englishDocTypeMappings;
              selectedLangDateMappings = englishDateMappings;
            }
          }

          this.selectedAppLanguageJson = JSON.parse(selectedLanguageMappings?.languageMappingJSON ?? englishLanguageMappings.languageMappingJSON);
          this.defaultEnglishJson = JSON.parse(englishLanguageMappings.languageMappingJSON);

          this.selectedLangDocTypeJson = JSON.parse(selectedLangDocTypeMappings?.languageMappingJSON ?? englishDocTypeMappings.languageMappingJSON);
          this.defaultEngDocTypeJson = JSON.parse(englishDocTypeMappings.languageMappingJSON);

          this.selectedLangDateJson = JSON.parse(selectedLangDateMappings?.languageMappingJSON ?? englishDateMappings.languageMappingJSON);
          this.defaultEngDateJson = JSON.parse(englishDateMappings.languageMappingJSON);

          this.docDateDesc = this.labelReplacer('txtDocDate');

          this.setCalendarLocale();

          this.isFontLoaded = true;
          this.islabelLoaded = true;
          this.spinner.hide();
          resolve(1);
        }
        else {
          this.spinner.hide();
        }
      });
    })
      .catch(err => {
        this.spinner.hide();

        console.log(err);
      });
  }


  labelReplacer(labelKey): string {
    let value;
    value = this.selectedAppLanguageJson[labelKey]?.trim() ? this.selectedAppLanguageJson[labelKey] ?? 'text not found' : this.defaultEnglishJson[labelKey] ?? 'text not found';
    return value;
  }

  docTypeReplacer(labelKey): string {
    return this.selectedLangDocTypeJson[labelKey]?.trim() ? this.selectedLangDocTypeJson[labelKey] ?? 'text not found' : this.defaultEngDocTypeJson[labelKey] ?? 'text not found';
  }

  calendarReplacer(labelKey): string {
    return this.selectedLangDateJson[labelKey]?.trim() ? this.selectedLangDateJson[labelKey] ?? 'text not found' : this.defaultEngDateJson[labelKey] ?? 'text not found';
  }

  dayOrMonthNameShort(name, length): string {
    let shortName = '';
    if (name?.trim()?.length == 0)
      shortName = 'Text not found';
    else if (name?.trim()?.length > 0 && name?.trim()?.length < length)
      shortName = name;
    else
      shortName = name.substr(0, length);
    return shortName;
  }

  buildForm() {

    this.documentForm = this.formBuilder.group({
      docTitle: ['', Validators.required],
      docDescription: ['', Validators.required],
      docType: ['', Validators.required],
      docDate: [''],
      approvalRequestedFrom: ['']
    });

  }

  getDocType() {
    return new Promise((resolve, reject) => {

      this.manageDocService.getDocType().subscribe(res => {
        if (res) {
          //success
          this.docTypeKeyValueList = res.data.map(x => ({
            label: this.docTypeReplacer(x.documentTypeId),
            value: x.documentTypeId
          }));
          this.docTypeList = res.data;
          console.log(this.docTypeKeyValueList);
          this.isDocTypeLoaded = true;
          resolve(1);
        } else {
          //display error
          reject();
        }
      })
    });
  }


  getLanguageList() {
    return new Promise((resolve, reject) => {
      this.labelCardService.getLanguageList().subscribe(res => {
        if (res) {
          //success
          // this.appLangList = res;
          res.forEach(element => {
            if (element.isAppLanguage) {
              this.appLangList.push({
                languageId: element.languageId,
                languageName: element.name,
                languageFlagPath: element.languagePath
              });
            }

          });
          console.log(res);
        } else {
          //display error
        }
        resolve(1);
      });
    });
  }

  setDocDateValidators() {
    this.docDateDesc = this.labelReplacer('txtDocDate');
    this.documentForm.get('docType').valueChanges
      .subscribe(docTypeValue => {
        this.getDocTypeDetails(docTypeValue);
      });
  }

  getDocTypeDetails(docTypeValue) {
    const docDateControl = this.documentForm.get('docDate');
    let docTypeData = this.docTypeList.filter(x => x.documentTypeId === docTypeValue)[0];
    if (docTypeValue) {
      if (docTypeValue === 1 ||
        docTypeValue === 2 ||
        docTypeValue === 3 ||
        docTypeValue === 5) {
        docDateControl.setValidators([Validators.required]);
        this.documentForm.patchValue({
          docDate: null
        });
        this.showDateMandatory = true;
      }
      else if (docTypeValue === 4 ||
        docTypeValue === 6) {
        docDateControl.setValidators(null);
        this.documentForm.patchValue({
          docDate: new Date()
        });
        this.showDateMandatory = false;

      }

      this.docInfo = "";
      this.docDateDesc = this.docTypeReplacer('d' + docTypeValue.toString())//docTypeData?.descriptionOfDate;
      if (docTypeData?.preferredNamingConvention && docTypeData?.preferredNamingConvention != '')
        this.docInfo = this.labelReplacer('msgFileNameFyi') + ': ' + this.docTypeReplacer('f' + docTypeValue.toString()) + ', ';
      this.docInfo +=  this.labelReplacer('msgProtectPdf') + ' ' + (docTypeData?.protectPdf ? this.docTypeReplacer('ppdftrue') : this.docTypeReplacer('ppdffalse'));

    }

    docDateControl.updateValueAndValidity();
  }


  getApproverList(engagementId) {
    return new Promise((resolve, reject) => {

      this.spinner.show();
      this.manageDocService.getApproverList(engagementId).subscribe(res => {
        if (res.status === 0) {
          //success
          this.rawApproverList = res.data;
          this.spinner.hide();
        } else {
          //display error
          this.spinner.hide();
        }
        resolve(1);
      });
    });
  }

  formatApproverList() {
    return new Promise((resolve, reject) => {
      let ownerList, reviewerList, partnerList, srMangerList, adminList: any[] = [];
      this.authorizerList = [];

      this.authorizerList.push({
        label: this.labelReplacer('lblOwner'),
        items: []
      });
      this.authorizerList.push({
        label: this.labelReplacer('lblReviewer'),
        items: []
      });
      this.authorizerList.push({
        label: this.labelReplacer('lblPPAP'),
        items: []
      });
      this.authorizerList.push({
        label: this.labelReplacer('lblSrManager'),
        items: []
      });
      this.authorizerList.push({
        label: this.labelReplacer('lblAdmin'),
        items: []
      });

      if (this.rawApproverList.length > 0) {
        ownerList = this.rawApproverList[0];
        reviewerList = this.rawApproverList[1];
        partnerList = this.rawApproverList[2];
        srMangerList = this.rawApproverList[3];
        adminList = this.rawApproverList[4];

        this.setDesignationList(ownerList, 0);
        this.setDesignationList(reviewerList, 1);
        this.setDesignationList(partnerList, 2);
        this.setDesignationList(srMangerList, 3);
        this.setDesignationList(adminList, 4);

      }

      resolve(1);
    })
      .catch(error => {
        console.log(error);
      })
  }

  setDesignationList(userList, index) {

    if (userList.length > 0) {
      this.authorizerList[index].items = userList.map(x => ({
        label: x.emailId,
        value: x.emailId
      }));
    }
  }

  save() {
    this.formSubmitted = true;
    this.apporveBtnState = true;
    this.spinner.show();
    if (this.documentForm.invalid) {
      this.spinner.hide()
      this.apporveBtnState = false;
      return
    }
    this.saveDocument('save')
      .then((res) => {
        this.apporveBtnState = false;
        this.emitDocument.emit(this.emitVersionResponse);
        this.spinner.hide();

      })
      .catch(err => {
        this.manageDocService.deleteDocVersion(this.emitVersionResponse?.versionData).subscribe(res => {
          if (res.status === 0) {

          }
          else {
            console.log(res?.message);
          }
        });
        console.log(err);
      })
  }

  saveDocument(saveType: string) {
    return new Promise((resolve, reject) => {
      // stop here if form is invalid
      let documentData = {
        ...this.documentForm.value,
        'engagementId': this.engagementDetail.engagementId,
        'folderId': this.docFolderId,
        'languageId': this.docLanguageId,
        'docId': 0,
        'docVersionId': 0,
        'statusId': 1,
        'documentDate': (this.documentForm.controls['docDate']?.value == null ||
          this.documentForm.controls['docDate']?.value == undefined ||
          this.documentForm.controls['docDate']?.value == '') ? null : new Date(this.documentForm.controls['docDate'].value).toDateString(),
        'docName': this.pUpload ? this.pUpload.name : '',
        'absoluteFilePath': this.absoluteFilePath
      }
      const formData = new FormData();
      if (this.pUpload) {
        let fileToUpload = <File>this.pUpload;
        if (fileToUpload.name.includes('eicar.com')) {
          this.spinner.hide();
          return;
        }
        else {
          formData.append('file', fileToUpload, fileToUpload.name);
        }
      }

      formData.append('fileJson', JSON.stringify(documentData));
      this.manageDocService.uploadNewDocument(formData).subscribe(res => {
        if (res.status === 0) {
          //success
          if (res.data) {
            this.resetForm();
            this.emitVersionResponse.versionData = res?.data;
            this.emitVersionResponse.saveType = saveType;
          }
          resolve(true);

        } else {
          //display error
          this.resetForm();
          this.errorMsg = res?.message;
          this.spinner.hide();
          this.messageService.add({
            summary: 'Error : Unable to save document version',
            detail: this.errorMsg,
            sticky: false,
            severity: 'error'
          });
          reject(false);
        }

      });


    })
      .catch(error => {
        console.log(error);
        this.spinner.hide();
      })

  }

  approverChange(event) {
    this.approverCheck(event?.value);
  }

  approverCheck(selectedApprover) {
    this.approverRemovedNote = null;
    if (selectedApprover) {
      //check if user exists in approver list
      if (this.findAuthorizer(selectedApprover)) {
        this.isApproverSelected = true;
        if (selectedApprover?.toString().toLowerCase() === this.userDetail?.emailId?.toLowerCase()) {
          this.showApproveButton = true;
        }
        else {
          this.showApproveButton = false;
        }
      }
      else {
        this.isApproverSelected = false;
        this.showApproveButton = false;
        this.approverRemovedNote = this.labelReplacer('msgApproverNotExists');
      }
    }
    else {
      this.isApproverSelected = false;
    }

  }


  findAuthorizer(selectedApprover): any {
    let authIndex = -1;
    let searchObj = null;
    this.authorizerList.forEach(x => {
      if ((authIndex = x.items.findIndex(y => y.label?.toLowerCase() ?? '' === selectedApprover.toLowerCase())) > -1) {
        searchObj = {} = x.items[authIndex];
      }
    });

    return searchObj;
  }

  approveDocumentVersion(approvalType: string) {
    this.apporveBtnState = true;
    
    this.spinner.show();
    this.formSubmitted = true;
    
    if (this.documentForm.invalid) {
      this.spinner.hide()
      this.apporveBtnState = false;
      return
    }

    if (this.canApprovalBeSent()) {
      //approval type = others ->save version / send email / mark version as pending approval
      this.emitVersionResponse.saveType = approvalType;
      if (approvalType.toLowerCase() === 'other') {
        this.saveDocument('approve')
          .then((res) =>
            this.sendApprovalMail()
              .then((res) => {
                this.apporveBtnState = false;
                this.emitVersionResponse.saveType = approvalType;
                this.emitDocument.emit(this.emitVersionResponse);
                this.spinner.hide();

              })
              .catch((error) => {
                console.log(error);
                this.spinner.hide();
              }))
          .catch((error) => {
            console.log(error)
            this.spinner.hide();
          });
      }
      else if (approvalType.toLowerCase() === 'self') {
        //if approval type = self -> approve version
        this.saveDocument('approve')
          .then((res) =>
            this.approve()
              .then((res) => {
                this.spinner.hide();
                this.emitVersionResponse.saveType = approvalType;
                this.emitDocument.emit(this.emitVersionResponse);
                this.apporveBtnState = false;
              })
              .catch((error) => {
                console.log(error);
                this.spinner.hide();
              }))
          .catch((error) => {
            console.log(error)
            this.spinner.hide();
          });

      }

    }
    else {
      this.messageService.add({
        summary: this.labelReplacer('msgErrorTypeApprovalReq'),
        detail: this.labelReplacer('msgErrorFileMissing'),
        sticky: false,
        severity: 'error'
      });
    }

    this.spinner.hide();
  }

  canApprovalBeSent(): boolean {

    let isAllowed = false;
    if (this.checkForAttachmentInDraft()) {
      isAllowed = true;
    }
    else {
      isAllowed = false;
    }

    return isAllowed;

  }

  checkForAttachmentInDraft(): boolean {
    let isFileExists = false;
    if (this.pUpload?.name !== null
      && this.pUpload?.name !== undefined
      && this.pUpload?.name !== '') {
      isFileExists = true;
    }
    else {
      isFileExists = false;
    }

    return isFileExists;
  }

  approve() {
    this.spinner.show();
    let approveVersion = {};
    approveVersion = this.emitVersionResponse?.versionData;
    approveVersion['absoluteFilePath'] = this.absoluteFilePath;
    return new Promise((resolve, reject) => {
      this.manageDocService.approveDocumentVersion(approveVersion).subscribe(res => {
        if (res.status === 0) {
          //success
          resolve(true);
        }
        else {
          //display error
          this.spinner.hide();
          console.log(res.message);
          reject(false);
        }

      });
    });
  }

  sendApprovalMail() {
    this.spinner.show();
    let approveVersion = {};
    approveVersion = this.emitVersionResponse?.versionData;
    //approveVersion['authorizerEmail'] = this.findAuthorizer(approveVersion['approvalRequestedFromGpn']);
    approveVersion['absoluteFilePath'] = this.absoluteFilePath;
    return new Promise((resolve, reject) => {
      this.manageDocService.sendDocumentApprovalMail(approveVersion).subscribe(res => {
        if (res?.data) {
          //success
          resolve(true);
        }
        else {
          //display error
          this.spinner.hide();
          console.log(res?.message);
          reject(false);
        }
      });
    });
  }

  omit_special_char(event) { 
    var k;
    k = event.charCode; //         k = event.keyCode;  (Both can be used)    
    //return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57)); }
    return(k != 47 && k != 92 && k != 58 && k != 42 && k != 63 && k!= 34 && k != 60 && k!= 62 && k != 124); }
    

  onUpload(event) {
    for (let file of event.files) {
      this.pUpload = file;
    }
  }

  resetForm() {
    this.formSubmitted = false;
    this.documentForm.controls['docTitle'].setValue('');
    this.documentForm.controls['docDescription'].setValue('');
    this.documentForm.controls['docType'].setValue('');
    this.documentForm.controls['docDate'].setValue('');
    this.documentForm.controls['approvalRequestedFrom'].setValue('');
    this.pUpload = null;
    this.docInfo = '';
    this.docDateDesc = this.labelReplacer('txtDocDate');
    this.ctrlFileUpload['files'] = [];
  }

  onFileRemove(event) {
    this.pUpload = null;
  }

}
